import Crud from "../Crud";

/**
 * Static helper functions related to notes.
 */
export default class Note extends Crud {
  /**
   * Returns whether the note may contain sensitive SSN data.
   * Requires both SSN label and SSN-like digits.
   *
   * @param {object} note The note object.
   * @returns {boolean}
   */
  static mayContainSensitiveDataSSN(note) {
    const text = typeof note?.text === "string" ? note.text : "";
    const hasSsnLabel =
      /\b(?:social security(?: number)?|ssn|ss|social)\b/i.test(text);
    const hasSsnDigits = /\b\d(?:[\s.-]?\d){8}\b/i.test(text);

    return hasSsnLabel && hasSsnDigits;
  }

  /**
   * Returns sensitive data categories that may exist in a note.
   *
   * @param {object} note The note object.
   * @returns {string[]} Array of sensitive categories found.
   */
  static mayContainSensitiveData(note) {
    const found = new Set();

    if (Note.mayContainSensitiveDataSSN(note)) {
      found.add("SSN");
    }

    return Array.from(found);
  }
}
